import React from 'react'
import './contact.css'

const Contact = () => {
  return (
    <div id='contact' className='container contact'>
<h1>keep in touch with me , say hi !</h1>
<button type='submit'><a href="mailto:khalidhassan218@outlook.com">start conversation </a></button>


    </div>
  )
}

export default Contact